<template>
  <div class="tabs" data-type="static">
    <ul role="tablist" class="nav nav-tabs">
      <li role="presentation" class="nav-item lisaweb">
        <span
          role="tab"
          tabindex="-1"
          :class="['nav-link', { active: active === 'registries' }]"
          @click="onClickRegistries()"
          >Clienti</span
        >
      </li>
      <li role="presentation" class="nav-item lisaweb">
        <span
          role="tab"
          tabindex="-1"
          :class="['nav-link', { active: active === 'groups' }]"
          @click="onClickGroups()"
          >Gruppi</span
        >
      </li>
      <li role="presentation" class="nav-item lisaweb">
        <span
          role="tab"
          tabindex="-1"
          :class="['nav-link', { active: active === 'policies' }]"
          @click="onClickPolicies()"
          >Polizze</span
        >
      </li>
      <li role="presentation" class="nav-item lisaweb">
        <span
          role="tab"
          tabindex="-1"
          :class="['nav-link', { active: active === 'claims' }]"
          @click="onClickClaims()"
          >Sinistri</span
        >
      </li>
      <li role="presentation" class="nav-item lisaweb">
        <span
          role="tab"
          tabindex="-1"
          :class="['nav-link', { active: active === 'contacts' }]"
          @click="onClickContacts()"
          >Contatti</span
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "StaticTabsWallet",
  components: {},
  data() {
    return {};
  },
  props: {
    active: {
      type: String,
      default() {
        return "";
      },
    },
  },
  methods: {
    onClickRegistries() {
      this.$router.push({
        name: `registries.index`,
      });
    },
    onClickGroups() {
      this.$router.push({
        name: `registry_groups.index`,
      });
    },
    onClickPolicies() {
      this.$router.push({
        name: `insurance_policies.index`,
      });
    },
    onClickClaims() {
      this.$router.push({
        name: `claims.index`,
      });
    },
    onClickContacts() {
      this.$router.push({
        name: `agency_contacts.index0`,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.tabs {
  &[data-type="static"] {
    li {
      cursor: pointer;
    }
  }
}
</style>
